// EditGroup.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import backend from "../../../../../api";
import AppHeader from "../../../../../components/AppHeader";
import "./EditGroup.css";
import { useSelector } from "react-redux";

export default function EditGroup() {
  const { groupId } = useParams();
  const nav = useNavigate();
  const { user } = useSelector(s => s.auth);
  const userId = user?._id;

  const [g, setG] = useState(null);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [full, setFull] = useState("");
  const [err, setErr] = useState("");

  const load = async () => {
    try {
      setErr("");
      const res = await backend.get(`/groups/${groupId}`);
      setG(res?.data?.data); setName(res?.data?.data?.name || "");
    } catch (e) {
      setErr(e?.response?.data?.message || "Failed to load");
    }
  };

  useEffect(()=>{ load(); },[groupId]);

  const rename = async () => {
    try {
      await backend.put(`/groups/${groupId}`, { name });
      load();
    } catch (e) {
      setErr(e?.response?.data?.message || "Rename failed");
    }
  };

  const addManual = async () => {
    try {
      if (!phone && !full) return;
      const idLike = prompt("Enter userId to add (for demo):");
      if (!idLike) return;
      await backend.post(`/groups/${groupId}/members`, { memberIds: [idLike] });
      setPhone(""); setFull(""); load();
    } catch (e) { setErr(e?.response?.data?.message || "Add failed"); }
  };

  const removeMember = async (mid) => {
    try {
      await backend.delete(`/groups/${groupId}/members/${mid}`);
      load();
    } catch (e) { setErr(e?.response?.data?.message || "Remove failed"); }
  };

  const goChat = () => nav(`/groups/${groupId}/chat`);

  return (
    <div className="eg-page">
      <AppHeader title="Edit group" onBack={() => nav(-1)} right={<button className="eg-chat" onClick={goChat}>Go to chat</button>} />
      {err && <div className="eg-error">{err}</div>}

      <div className="eg-card">
        <div className="eg-section-title">Edit group</div>
        <input className="eg-input" value={name} onChange={e=>setName(e.target.value)} placeholder="Change group name" />
        <button className="eg-btn" onClick={rename}>Save name</button>

        <div className="eg-section-title mt16">Add group member</div>
        <div className="eg-row">
          <input className="eg-input" placeholder="Full name (UI only)" value={full} onChange={e=>setFull(e.target.value)} />
          <input className="eg-input" placeholder="Phone number (UI only)" value={phone} onChange={e=>setPhone(e.target.value)} />
          <button className="eg-btn" onClick={addManual}>Add member</button>
        </div>
      </div>

      <div className="eg-list">
        <div className="eg-subtitle">Group members</div>
        {g?.members?.map(m => (
          <div className="eg-item" key={m._id}>
            <div className="eg-avatar">👤</div>
            <div className="eg-name">{m.name || m._id}</div>
            {String(m._id) !== String(userId) && (
              <>
                <button className="eg-chat" onClick={()=>nav(`/dm/${m._id}`)}>Chat</button>
                <button className="eg-call" onClick={()=>nav(`/call/${m._id}`)}>Call</button>
              </>
            )}
            <button className="eg-remove" onClick={()=>removeMember(m._id)}>Remove</button>
          </div>
        ))}
      </div>
    </div>
  );
}